import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="页面不存在 · 爆料91"
        description="你访问的页面可能已被调整或链接有误，返回首页或热议话题列表继续浏览爆料91的热门讨论。"
        path="/"
      />
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="text-center max-w-lg">
          <span className="font-logo text-6xl md:text-8xl text-primary-500">404</span>
          <h1 className="mt-6 text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            这个页面溜去别的地方吃瓜了
          </h1>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            你要找的内容可能已经被合并进其他话题，或者链接不太对。别急，下面两个入口都能继续逛。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-home-4-line"></i>
              回到首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-background-300 text-foreground-800 text-sm font-bold whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors"
            >
              <i className="ri-fire-line"></i>
              浏览热议话题
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}